import { TimesheetType } from "@crimsontide/core/client/interfaces";
import DotNetObject = DotNet.DotNetObject;

export const TimesheetTypeService = (() => {
  let dotNetObj: DotNetObject;
  let cachedTimesheetTypes: TimesheetType[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getTimesheetTypes = async (useCache: boolean = true): Promise<TimesheetType[]> => {
    if (useCache && cachedTimesheetTypes != null)
      return cachedTimesheetTypes;

    if (dotNetObj) {
      cachedTimesheetTypes = await dotNetObj.invokeMethodAsync<TimesheetType[]>('GetAsync');
      return cachedTimesheetTypes;
    } else {
      throw 'Timesheet Type DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getTimesheetTypes,
  };
})();
